import { Typography, Box, Button, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { GuestGroup } from '../services/api';

interface RSVPConfirmationProps {
  submittedRSVPs: Record<string, any>;
  submittedGroup: GuestGroup;
  groupEmail: string;
  onEditRSVP: () => void;
}

export default function RSVPConfirmation({ 
  submittedRSVPs, 
  submittedGroup, 
  groupEmail, 
  onEditRSVP 
}: RSVPConfirmationProps) {
  return (
    <>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <CheckCircleOutlineIcon 
          sx={{ 
            fontSize: 48, 
            color: 'rgba(175, 99, 42, 1)',
            mb: 2 
          }} 
        />
        <Typography variant="h4" sx={{ mb: 1, fontFamily: '"Playfair Display", serif' }}>
          RSVP Saved
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We're so excited that you will be able to make our wedding celebration!
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Review your details below.
        </Typography>
        <Button
          variant="contained"
          onClick={() => {console.log("Clicked"); onEditRSVP()}}
          sx={{
            backgroundColor: 'rgba(175, 99, 42, 1)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(187, 138, 101, 1)',
            },
          }}
        >
          Edit RSVP
        </Button>
      </Box>

      <Box sx={{ textAlign: 'left', mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2, fontFamily: '"Playfair Display", serif' }}>
          WELCOME PARTY
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Join us for a welcome party at the Cactus Jack's Saloon & Grill to start the weekend celebrations!
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Cactus Jack's Saloon & Grill
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Friday, August 1st
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          6:00 PM - 8:00 PM
        </Typography>
        <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 3 }}>
          Casual Attire
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          We will be serving light hors d'oeuvres, beer and wine.
        </Typography>

        {submittedGroup.guests.map(guest => (
          <Box key={guest.guestId} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography>{guest.firstName} {guest.lastName}</Typography>
            <Typography>
              {submittedRSVPs[guest.guestId]?.welcomeParty?.attending ? 'Will attend' : 'Will not attend'}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="h5" sx={{ mb: 2, fontFamily: '"Playfair Display", serif' }}>
          WEDDING
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Echo Mountain
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          19285 CO-103
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Idaho Springs, CO 80452
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Saturday, August 2nd, 4:00 PM - 10:00 PM
        </Typography>

        {submittedGroup.guests.map(guest => (
          <Box key={guest.guestId} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography>{guest.firstName} {guest.lastName}</Typography>
            <Typography>
              {submittedRSVPs[guest.guestId]?.wedding?.attending ? 'Will attend' : 'Will not attend'}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="h5" sx={{ mb: 2, fontFamily: '"Playfair Display", serif' }}>
          CONTACT INFORMATION
        </Typography>
        
        <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
          Email Address
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          {groupEmail || 'Not provided'}
        </Typography>
      </Box>

      <Divider sx={{ my: 4 }} />
    </>
  );
}
